import React from 'react';
import Login from '../Logins/Login';

const LoginPage = () => {
    return (
        <>
        <Login />
        </>
    );
};

export default LoginPage;